module.exports = __webpack_public_path__ + "img/videoBg.bf21edf2.png";